import { useMutation, useQueryClient } from "@tanstack/react-query";

import { type PutAttendanceDayInput, putAttendanceDay } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import type { AttendanceDay } from "../types";
import { toAttendanceDay } from "../utils/map";
import { invalidateAttendance } from "./invalidate-attendance";

export interface PutDayInput extends PutAttendanceDayInput {
	workerId: string;
	date: string;
}

export function usePutDay() {
	const queryClient = useQueryClient();
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: async (input: PutDayInput): Promise<AttendanceDay> => {
			const { workerId, date, ...body } = input;
			return toAttendanceDay(
				await putAttendanceDay(
					activeCanteiroId as string,
					workerId,
					date,
					body,
				),
			);
		},
		onSuccess: () => invalidateAttendance(queryClient),
	});
}
